import { serverUrl } from "../../App"

export const getCoords = async () => {
    const pos = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });

    return {
      lon: pos.coords.longitude,
      lat: pos.coords.latitude,
    };
};

export const createVisitor = async (visitor) => {

    try {
        const res = await fetch(`${serverUrl}/visitor/create`,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(visitor)
        });
        if (res.status === 201) {
            return true
        }
    } catch (e) {
        console.error(e)
    }
}

export const getVisitorAPICall = async (id) => {
    try {
        const visitor = await fetch(`${serverUrl}/visitor/?id=${id}`)
        const response = await visitor
        if (response.status === 200) {
            return true
        } else if (response.status === 404) {
            const coordinates = await getCoords(); 
            const tempVis = {...visitor,id:id,geo:{lat:coordinates.lat,lon:coordinates.lon}};
            await createVisitor(tempVis) 
            return false        
        }
    } catch (e) {
        console.error(e)
    }
}

export const updateVisitor = async(visitor) => {
    try {
        const res = await fetch(`${serverUrl}/visitor/update`,{
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(visitor)
        });
        const data = await res;
    } catch (e) {
        console.error(e)
    }
}